import InvalidIcon from '../../../resources/invalidIcon.png'
import validIcon from '../../../resources/validIcon.png'

import './VerificationIndicationIcon.css'

const VerificationIndicationIcon = ({ isValid, isVisible }) => {
  if (!isVisible) {
    return null
  }

  return isValid ? (
    <img src={validIcon} alt="" className="valid-code-icon" />
  ) : (
    <img src={InvalidIcon} alt="" className="invalid-code-icon" />
  )
}

export default VerificationIndicationIcon
